import { orderObjectKeys } from './helper'

const charToRemove = ['?', '*']
const verbose = false

export const apiParam = '&method=textacy-np'

export const sanitiseResearchQuestion = (string) => {
  let result = string
  for (const el of charToRemove) {
    while (result.includes(el)) {
      result = result.replace(el, '')
    }
  }
  return result
}

export const getNonFacetQuery = (researchQuestion, responseArray) => {
  let nonFacetQuery = researchQuestion
  for (let phrase of responseArray) {
    const splitString = nonFacetQuery.split(phrase)
    if (splitString.length === 2) {
      nonFacetQuery = splitString.join()
    } else if (splitString.length > 2) {
      const [first, ...rest] = nonFacetQuery.split(phrase) // Makes sure to take 1st occurrence of phrase only
      nonFacetQuery = first + ',' + rest.join(phrase)
    }
  }
  return nonFacetQuery
}

export const formatResponse = (response, term) => {
  // eslint-disable-next-line no-return-assign,no-sequences
  let formattedResponse = response.reduce((acc, curr) => (acc[curr] = {isSelected: false, isShowing: false}, acc), {})
  formattedResponse = Object.assign({[term.phrase.join(' ')]: {isSelected: true, isShowing: false}}, formattedResponse)
  return orderObjectKeys(formattedResponse)
}

export const craftResearchQuestionProcessed = (responseArray, researchQuestion) => {
  let researchQuestionProcessed = []
  let nonFacetQuery = getNonFacetQuery(researchQuestion, responseArray)
  let nonFacetQueryArray = nonFacetQuery.split(',').filter(el => el !== '' && el !== ' ')
  if (verbose) { console.log('nonFacetQueryArray:', nonFacetQueryArray) }
  const loopNumber = Math.max(responseArray.length, nonFacetQueryArray.length)
  if (verbose) { console.log('loopNumber:', loopNumber) }
  let tempResearchQuestion = researchQuestion

  for (let i = 0; i < loopNumber; i++) {
    let indexFacet = tempResearchQuestion.search(responseArray[i])
    let indexNonFacet = tempResearchQuestion.search(nonFacetQueryArray[i])
    if (indexFacet === -1 || indexNonFacet === -1) {
      if (verbose) { console.log('skippedLoop-indexFacet:', indexFacet, ', indexNonFacet:', indexNonFacet) }
      continue
    }
    if (responseArray[i] === undefined || indexFacet < 0) {
      if (verbose) { console.log('AddedNonFacet:', nonFacetQueryArray[i]) }
      tempResearchQuestion = tempResearchQuestion.replace(nonFacetQuery[i], '')
      researchQuestionProcessed.push({ phrase: [nonFacetQueryArray[i]], isFacet: false, isShowing: false })
    } else if (nonFacetQueryArray[i] === undefined) {
      if (verbose) { console.log('AddedFacet:', responseArray[i]) }
      tempResearchQuestion = tempResearchQuestion.replace(responseArray[i], '')
      researchQuestionProcessed.push({ phrase: responseArray[i].split(' '), isFacet: true, isShowing: false })
    } else if (indexFacet < indexNonFacet) {
      if (verbose) { console.log('reordered-Facets:', responseArray[i], ' + nonFacet:', nonFacetQueryArray[i]) }
      tempResearchQuestion = tempResearchQuestion.replace(responseArray[i], '')
      tempResearchQuestion = tempResearchQuestion.replace(nonFacetQueryArray[i], '')
      researchQuestionProcessed.push({ phrase: responseArray[i].split(' '), isFacet: true, isShowing: false })
      researchQuestionProcessed.push({ phrase: [nonFacetQueryArray[i]], isFacet: false, isShowing: false })
    } else {
      if (verbose) { console.log('reordered-NonFacets:', nonFacetQueryArray[i], ' + Facet:', responseArray[i]) }
      tempResearchQuestion = tempResearchQuestion.replace(nonFacetQueryArray[i], '')
      tempResearchQuestion = tempResearchQuestion.replace(responseArray[i], '')
      researchQuestionProcessed.push({ phrase: [nonFacetQueryArray[i]], isFacet: false, isShowing: false })
      researchQuestionProcessed.push({ phrase: responseArray[i].split(' '), isFacet: true, isShowing: false })
    }
  }
  return researchQuestionProcessed
}

export const generateSearchQueryOrdered = (relevantKeywords) => {
  let index = 0
  let queryString = ''
  for (const group in Object.keys(relevantKeywords)) {
    for (const facet in relevantKeywords[group]) {
      const facetContent = relevantKeywords[group][facet]
      queryString = queryString.concat('', '(')
      Object.entries(facetContent.terms)
        .filter(element => element[1].isSelected)
        .forEach(([keyterm, state], keywordIndex) => {
          queryString = queryString.concat('', keywordIndex === 0 ? keyterm : ` OR ${keyterm}`)
        })
      if (index + 1 === Object.entries(relevantKeywords).length) {
        queryString = queryString.concat('', ')')
      } else {
        queryString = queryString.concat('', ') AND ')
      }
      index++
    }
  }
  return queryString
}



//////////////////
// WEBPACK FOOTER
// ./store/aiHelper.js
// module id = null
// module chunks = 